import { EVMInterface, BTCInterface, MultichainExecutionResponse, InitializationConfig } from './types';

export default class MultichainExecutor {
  constructor(args: InitializationConfig) {
    console.log('args', args);
  }

  async signAndSendEthTransaction(data: EVMInterface): Promise<MultichainExecutionResponse> {
    console.log('signAndSendEthTransaction called', data);
    return Promise.resolve({
      success:         true,
      transactionHash: 'hello',
    });
  }

  async signAndSendBtcTransaction(data: BTCInterface): Promise<MultichainExecutionResponse> {
    console.log('signAndSendBtcTransaction called', data);
    return Promise.resolve({
      success:         true,
      transactionHash: 'hello',
    });
  }

  async signEthTransaction(data: EVMInterface): Promise<string> {
    console.log('signEthTransaction called', data);
    return Promise.resolve('test');
  }

  async signBtcTransaction(data: BTCInterface): Promise<string> {
    console.log('signBtcTransaction called', data);
    return Promise.resolve('test');
  }
}
